module.exports = __webpack_public_path__ + "img/modal-btn-bg-2.44b4d536.png";